import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

function PNF() {
  const navigate = useNavigate();
  useEffect(() => {
    let token = localStorage.getItem("chatappsessiontoken");
    if (token !== null) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
  });
  return;
}

export default PNF;
